import { FullPageLoadingOverlayFallback } from '@xarvio/frontend-core-app-wrapper/lib/FullPageLoadingOverlay/FullPageLoadingOverlay';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getIsUserLoggedInSelector } from '@xarvio/frontend-core-state/lib/auth/selectors';

import { CrossFarmDashboardPageLoading } from '../pages/CrossFarmDashboard/loading/CrossFarmDashboardPageLoading';
import { HeaderLoadingSkeleton } from '../components/shared/Header/HeaderLoadingSkeleton';
import { LandingDestinationLoading } from './LandingDestinationLoading';
import { isBioenergyPathname } from './bioenergyRoute';
import { isCrossFarmDashboardPathname } from './crossFarmRoute';
import { isLocaleLandingRoute } from './landingRouteUtils';
import { AuthRoutesLoading } from './PublicRoutes/AuthRoutesLoading';
import { isPublicAuthRoute } from './PublicRoutes/authRouteUtils';
import {
  StatusInitialLoadingShell,
  TableStatusContentLoadingShell,
} from './StatusInitialLoadingShellProvider';
import {
  getStatusLoadingRoute,
  isNewStatusLoadingRoute,
  isTableStatusLoadingRoute,
} from './statusLoadingRoute';

export const RouteLoadingFallback = ({
  withHeader = true,
}: {
  withHeader?: boolean;
}) => {
  const { pathname } = useLocation();
  const isUserLoggedIn = useSelector(getIsUserLoggedInSelector);
  const statusLoadingRoute = getStatusLoadingRoute(pathname);
  const headerSkeleton = withHeader ? <HeaderLoadingSkeleton /> : null;

  if (isTableStatusLoadingRoute(statusLoadingRoute)) {
    return (
      <>
        {headerSkeleton}
        <TableStatusContentLoadingShell />
      </>
    );
  }

  if (isNewStatusLoadingRoute(statusLoadingRoute)) {
    return (
      <>
        {headerSkeleton}
        <StatusInitialLoadingShell loadingRoute={statusLoadingRoute} />
      </>
    );
  }

  if (isPublicAuthRoute(pathname)) {
    return <AuthRoutesLoading />;
  }

  if (isUserLoggedIn && isLocaleLandingRoute(pathname)) {
    return <LandingDestinationLoading />;
  }

  if (isCrossFarmDashboardPathname(pathname)) {
    return (
      <>
        {headerSkeleton}
        <CrossFarmDashboardPageLoading pathname={pathname} />
      </>
    );
  }

  if (isBioenergyPathname(pathname)) {
    return headerSkeleton;
  }

  return <FullPageLoadingOverlayFallback />;
};
